module.exports = __webpack_public_path__ + "static/media/doc-lg.e3e82682.png";